// Module
var code = "<div ng-show=\"selected\" class=\"flex-container-column flex\"> <form name=\"form\" class=\"flex-container-column flex\"> <div ng-transclude class=\"flex-container-column flex\"></div> </form> </div> ";
// Exports
module.exports = code;